import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../configs/constants';

axios.defaults.withCredentials = true;

export const sendFormData = async (data, path, isEdit = false) => {
    const formData = new FormData();

    for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
            formData.append(key, data[key]);
        }
    }

    const formattedPath = path.charAt(0) === '/' ? path : `/${path}`;
    const url = process.env.REACT_APP_CMS_API_PATH + formattedPath;

    const method = isEdit ? 'PATCH' : 'POST';
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;
    console.log('url end bna', url);
    console.log('FormData Entries 2:', Array.from(formData.entries()));

    return await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
    });
};
